// extracted by mini-css-extract-plugin
module.exports = {"redlBreadcrumbs":"Breadcrumbs_redlBreadcrumbs__wrFt_","redlBreadcrumbsList":"Breadcrumbs_redlBreadcrumbsList__uqHCK","redlBreadcrumbsIcon":"Breadcrumbs_redlBreadcrumbsIcon__0ODJi"};